import { injectable, inject } from 'inversify';
import { Message, Field, Type } from "protobufjs/light";
import { Result, ok } from '@xlearn/common'
import { ProtobufSerializer } from '@/app/state-serialization/infrastructure';
import * as Api from '@/app/state-serialization/api'
import { ExamSessionState } from '../../domain'
import { QuizSessionNavigationStateProtoMessage,
  QuizSessionQuestionStateProtoMessage,
  QuizSessionQuestionTimeStateProtoMessage,
  QuizSessionNavigationStateProtobufMapper,
  QuizSessionQuestionStatesProtobufMapper,
  QuizSessionQuestionTimesStateProtobufMapper} from '@/app/quiz-session/tracking/serialization/api';

@injectable()
export class ExamSessionStateProtobufSerializer implements Api.StateSerializationPlugin<ExamSessionState> {

  key = { id: 8, name: { ns: 'suspend-data', name: 'quiz-session-exam' }, format: 'protobuf' }

  constructor(
    @inject(QuizSessionNavigationStateProtobufMapper)
    private navigationMapper: QuizSessionNavigationStateProtobufMapper,
    @inject(QuizSessionQuestionStatesProtobufMapper)
    private answerMapper: QuizSessionQuestionStatesProtobufMapper,
    @inject(QuizSessionQuestionTimesStateProtobufMapper)
    private questionTimeMapper: QuizSessionQuestionTimesStateProtobufMapper) {

  }

  serialize(data: ExamSessionState): Result<Uint8Array, Api.SerializerError> {

    const message = new ExamSessionStateProtoMessage({
      startTime: ProtobufSerializer.serializeDate(data.startTime),
      questionIds: data.questionIds,
      navigation: this.navigationMapper.map(data.navigation),
      questionStates: this.answerMapper.map(data.questionStates),
      questionTimes: this.questionTimeMapper.map(data.questionTimes),
    })

    return ProtobufSerializer.serialize<ExamSessionStateProtoMessage>(message,
                                                                          ExamSessionStateProtoMessage)
  }

  deserialize(content: Uint8Array): Result<ExamSessionState, Api.DeserializerError> {

    const deserializeResult = ProtobufSerializer.deserialize<ExamSessionStateProtoMessage>(content,
                                                                                     ExamSessionStateProtoMessage)
    if (!deserializeResult.success) {
      return deserializeResult
    }

    const message = deserializeResult.value

    const result: ExamSessionState = {
      startTime: ProtobufSerializer.deserializeDate(message.startTime),
      questionIds: message.questionIds,
      navigation: this.navigationMapper.deserialize(message.navigation),
      questionStates: this.answerMapper.unmap(message.questionStates),
      questionTimes: this.questionTimeMapper.unmap(message.questionTimes),
    }
    return ok(result)
  }
}

@Type.d('ExamSessionStateProtoMessage')
class ExamSessionStateProtoMessage extends Message<ExamSessionStateProtoMessage> {

  @Field.d(1, 'uint32', 'optional', 1)
  public schemaVersion: number

  @Field.d(2, 'uint64', "optional", 0)
  startTime: Long
  
  @Field.d(3, 'string', 'repeated')
  questionIds: string[]

  @Field.d(4, QuizSessionNavigationStateProtoMessage)
  navigation: QuizSessionNavigationStateProtoMessage

  @Field.d(5, QuizSessionQuestionStateProtoMessage, 'repeated')
  questionStates: QuizSessionQuestionStateProtoMessage[]

  @Field.d(6, QuizSessionQuestionTimeStateProtoMessage, 'repeated')
  questionTimes: QuizSessionQuestionTimeStateProtoMessage[]
}

